import { SessionParams } from '@models/session-params';

type ResolvedSessionParams = Required<SessionParams>;

export function getSessionParams(): ResolvedSessionParams {
  const url = new URL(window.location.href);
  const queryParams = new URLSearchParams(url.search);
  const lang = queryParams.get('language') ?? '';
  const isAdmin = queryParams.get('admin') === 'true';
  const selectedLanguage = lang || 'en';
  return {
    gameUuid: queryParams.get('gameId')!,
    stageUuid: queryParams.get('stageUuid')!,
    versionHash: queryParams.get('versionHash')!,
    pathUuid: queryParams.get('pathUuid') ?? '',
    token: queryParams.get('token') ?? '',
    instance: queryParams.get('instance') ?? '',
    brand: queryParams.get('brand') ?? '',
    tags: queryParams.get('tags') ?? '',
    isFromHub: queryParams.get('hub') === 'true',
    isAdmin,
    hubGameUuid: queryParams.get('hubGameUuid') ?? '',
    language: selectedLanguage,
    bg: queryParams.get('bg') ?? '',
  };
}
